import React, { useState, useEffect } from "react";
import UseTermProvider from "../../../../../../shared/provider/UseTermProvider";
import DefaultButton from "../../../../../../shared/util/DefaultButton";
import CustomModal from "../../../../../../shared/util/AntModal/CustomModal";
import { ModalContent } from "./styles";
import { useSelection } from "../../../../../../shared/context/selection/selectionProvider";

const useTermProvider = new UseTermProvider();

const AcceptUseTermModal: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isReadOnly, setIsReadOnly] = useState(false); // Novo estado para verificar se o termo já foi assinado
  const { setUseTermModal, useTermModal, useTerm, handleLogout } = useSelection();

  useEffect(() => {
    const checkIfTermAccepted = async () => {
      try {
        const alreadyAccepted = await useTermProvider.validateUseTerm(useTerm.useTermId);
        setIsReadOnly(alreadyAccepted);
      } catch (error) {
        console.error("Erro ao validar termo de uso:", error);
      }
    };

    if (useTermModal) {
      checkIfTermAccepted();
    }
  }, [useTermModal, useTerm.useTermId]);

  const handleAccept = async () => {
    setLoading(true);
    try {
      await useTermProvider.acceptUseTerm(useTerm.useTermId);
      setSuccessMessage("Termo de uso aceito com sucesso");
    } catch (error) {
      console.error("Erro ao aceitar termo de uso:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = (leaving = true) => {
    if (leaving) {
      setUseTermModal(false);
      handleLogout();
    } else {
      setUseTermModal(false);
      setSuccessMessage("");
    }
  };

  return (
    <CustomModal
      title={<h2>Termo de Uso</h2>}
      visible={useTermModal}
      onCancel={() => handleCancel(!isReadOnly)}
      showWarning={false}
      showSuccess={!!successMessage}
      showSuccessOk={() => handleCancel(false)}
      successMessage={successMessage}
      onSuccessConfirm={() => handleCancel(false)}
      footer={
        !successMessage && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <DefaultButton
              key="cancel"
              width="150px"
              height="35px"
              fontSize="1em"
              withOutBackground={true}
              params={{
                type: "button",
                onClick: () => handleCancel(!isReadOnly),
              }}
            >
              Cancelar
            </DefaultButton>
            {!isReadOnly && ( // Exibe o botão "Aceitar" apenas se o termo não foi assinado
              <DefaultButton
                key="accept"
                width="150px"
                height="35px"
                fontSize="1em"
                params={{
                  type: "button",
                  onClick: handleAccept,
                  loading: loading,
                }}
              >
                Aceitar
              </DefaultButton>
            )}
          </div>
        )
      }
    >
      <ModalContent dangerouslySetInnerHTML={{ __html: useTerm.description }} />
    </CustomModal>
  );
};

export default AcceptUseTermModal;